// Recovered compiled webpack factory 25188. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { h: () => s });
  var n = i(29089);
  function s(t) {
    return (0, n.x)(t) && "svg" === t.tagName;
  }
}
